import { render, staticRenderFns } from "./stockTransfer.vue?vue&type=template&id=db4396f6&"
import script from "./stockTransfer.vue?vue&type=script&lang=js&"
export * from "./stockTransfer.vue?vue&type=script&lang=js&"
import style0 from "./stockTransfer.vue?vue&type=style&index=0&id=db4396f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports